/* eslint-disable import/prefer-default-export */
export const springTransition = {
  type: 'spring',
  damping: 25,
  stiffness: 150,
};
